"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapClosureStateToText = void 0;
const dayjs = require("dayjs");
const formatShortDate_1 = require("../formatShortDate");
const mapClosureStateToText = (closure) => {
    let text = "";
    switch (closure.reason) {
        case "FULLY_BOOKED":
            text += "Sorry, the course is fully booked on this day";
            break;
        case "CLOSED_TOURNAMENT":
            text += "Sorry, the course is closed for a tournament on this day";
            break;
        case "CLOSED_MAINTENANCE":
            text += "Sorry, the course is closed for maintenance on this day";
            break;
        case "CLOSED_FURTHER_NOTICE": {
            if (closure.end_date) {
                let date = closure.end_date;
                if (Number(closure.end_time.split(":")[0]) > 20) {
                    date = dayjs(closure.end_date).add(1, "day").toDate();
                }
                text += `Sorry, this course is closed until ${(0, formatShortDate_1.formatShortDate)(date)}`;
            }
            else {
                text += "Sorry, this course is closed until further notice";
            }
            break;
        }
        case "CLOSED_PERMANENTLY":
            text += "Sorry, this course is now permanently closed";
            break;
    }
    return text;
};
exports.mapClosureStateToText = mapClosureStateToText;
